import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.split";
import _reduce from "lodash/reduce";
import _size from "lodash/size";
export function toSentenceCase(str) {
  if (!str || _size(str) === 0) {
    return '';
  }

  var lowerCaseStr = str.toLowerCase();
  var upperCaseFirstLetter = lowerCaseStr.charAt(0).toUpperCase();
  return upperCaseFirstLetter + lowerCaseStr.slice(1);
}
export function toTitleCase(str) {
  if (!str || _size(str) === 0) {
    return '';
  }

  var strArr = str.split(' ');

  var titleCasedStr = _reduce(strArr, function (acc, word) {
    return "".concat(acc, " ").concat(toSentenceCase(word));
  }, '');

  return titleCasedStr.trim();
}